import { React, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormProvider, useForm, Controller } from "react-hook-form";

// @material-ui/core components
import {
  Container,
  Grid,
  FormGroup,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";

import FollowUpDetails from "../../../Components/OpportunityApplicationsFollowUp/FollowUpDetails";
import { OPPORTUNITY_CANDIDATE_FOLLOWUP_STATE_KEY } from "utils/const";
import { updateOpportunityFollowupPeriodAction } from "redux/actions/opportunitiesAction";
import { updateOpportunityFollowupPeriodMap } from "mappers/OpportunityMap";
import GenericButton from "components/Buttons/GenericButton";
import { completeApplicationFollowup } from "crud/opportunities.crud";
import { useMutation } from "@tanstack/react-query";
import { DIALOG } from "utils/actionsConsts";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import componentStylesGeneric from "assets/theme/views/admin/generic.js";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function FollowUpDetailsTab(props) {
  const history = useHistory();
  const [isEditable, setIsEditable] = useState(false);
  const dispatch = useDispatch();
  const methods = useForm({
    mode: "onChange",
  });
  const classes = useStylesGeneric();

  const completeFollowupForm = useForm({
    defaultValues: {
      wasHired: null,
    },
  });

  const cancelOnClick = () => {
    history.goBack();
  };

  function handleLog() {
    console.log(methods.formState.errors);
  }

  const handleEditSection = () => {
    setIsEditable(true);
  };

  function onSubmit(data) {
    data["candidateCode"] = props.opportunityApplicationFollowUpDetails?.candidateCode;

    let updateData = updateOpportunityFollowupPeriodMap(data);

    props.updateOpportunityFollowupPeriod(updateData, () => {
      props.handleRefreshPage();
    });
  }

  const { mutateAsync: completeFollowupMutation, isLoading: isCompletingFollowup } = useMutation(
    (data) => completeApplicationFollowup(data),
    {
      onSuccess: () => {
        dispatch({
          type: DIALOG.SHOW,
          payload: {
            showGenericDialog: true,
            genericDialogData: {
              type: DIALOG.ONE_BUTTON_TYPE,
              isSuccess: true,
              buttonLabel: "Ok",
              message: "Acompanhamento concluído com sucesso.",
            },
          },
        });
        props.handleRefreshPage();
      },
      onError: (error) => {
        console.error(error);
        dispatch({
          type: DIALOG.SHOW,
          payload: {
            showGenericDialog: true,
            genericDialogData: {
              type: DIALOG.ONE_BUTTON_TYPE,
              isSuccess: false,
              buttonLabel: "Ok",
              message: "Ocorreu um erro ao concluir o acompanhamento.",
            },
          },
        });
      },
    },
  );

  const onCompleteFollowup = async (data) => {
    if (data.wasHired === null) {
      completeFollowupForm.setError("wasHired", {
        type: "required",
        message: "Por favor, selecione uma opção.",
      });
      return;
    }

    await completeFollowupMutation({
      opportunityCandidateId: props.opportunityApplicationFollowUpDetails?.candidateCode,
      wasHired: data.wasHired === "true",
    });
  };

  return (
    <>
      <Container maxWidth={false}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <FollowUpDetails
              opportunityApplicationFollowUpDetails={props.opportunityApplicationFollowUpDetails}
              isEditable={isEditable}
              handleEditSection={handleEditSection}
              isUserColective={true}
            />
            {isEditable &&
              props.opportunityApplicationFollowUpDetails?.candidateFollowUpStateKey ===
                OPPORTUNITY_CANDIDATE_FOLLOWUP_STATE_KEY.PORINICIAR && (
                <>
                  <Grid container>
                    <Grid item xs={12} sm={2} md={6}></Grid>
                    <Grid item xs={12} sm={5} md={3}>
                      <FormGroup>
                        <GenericButton typeSubmit={false} color="secondary" onClick={() => cancelOnClick()}>
                          Cancelar
                        </GenericButton>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={5} md={3}>
                      <FormGroup>
                        <GenericButton
                          typeSubmit={true}
                          color="primary"
                          disabled={props.opportunitiesState?.update_opportunity_followup_period_loading}
                          loading={props.opportunitiesState?.update_opportunity_followup_period_loading}
                          onClick={() => handleLog()}
                        >
                          Guardar
                        </GenericButton>
                      </FormGroup>
                    </Grid>
                  </Grid>

                  <div style={{ marginBottom: "90px" }}> </div>
                </>
              )}
          </form>
          {!isEditable &&
            props.opportunityApplicationFollowUpDetails?.candidateFollowUpStateKey ===
              OPPORTUNITY_CANDIDATE_FOLLOWUP_STATE_KEY.PORINICIAR && <div style={{ marginBottom: "170px" }}> </div>}
        </FormProvider>

        {props.opportunityApplicationFollowUpDetails?.candidateFollowUpStateKey ===
          OPPORTUNITY_CANDIDATE_FOLLOWUP_STATE_KEY.TERMINADO &&
          props.opportunityApplicationFollowUpDetails.wasHired === null && (
            <Box mt={3}>
              <Card>
                <CardHeader
                  classes={{
                    action: classes.cardHeaderAction,
                    title: classes.cardHeader,
                  }}
                  title="Conclusão do Acompanhamento"
                ></CardHeader>
                <CardContent>
                  <FormProvider {...completeFollowupForm}>
                    <form onSubmit={completeFollowupForm.handleSubmit(onCompleteFollowup)}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Controller
                            name="wasHired"
                            control={completeFollowupForm.control}
                            rules={{ required: "Por favor, selecione uma opção." }}
                            render={({ field, fieldState: { error } }) => (
                              <FormControl component="fieldset" error={!!error}>
                                <FormLabel component="legend" style={{ marginBottom: "0.5rem" }}>
                                  Após a conclusão do estágio profissional, o mesmo foi convertido em posto de trabalho
                                  na entidade empregadora?{" "}
                                </FormLabel>
                                <RadioGroup {...field} row>
                                  <FormControlLabel value="true" control={<Radio color="primary" />} label="Sim" />
                                  <FormControlLabel value="false" control={<Radio color="primary" />} label="Não" />
                                </RadioGroup>
                                {error && (
                                  <Typography variant="caption" color="error">
                                    {error.message}
                                  </Typography>
                                )}
                              </FormControl>
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box display="flex" justifyContent="flex-end" gap={2}>
                            <GenericButton
                              typeSubmit={true}
                              color="primary"
                              loading={isCompletingFollowup}
                              disabled={isCompletingFollowup}
                            >
                              Concluir Acompanhamento
                            </GenericButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </form>
                  </FormProvider>
                </CardContent>
              </Card>
            </Box>
          )}
      </Container>
    </>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  updateOpportunityFollowupPeriod: (data, onCloseMethod) =>
    dispatch(updateOpportunityFollowupPeriodAction(data, onCloseMethod)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpDetailsTab);
